import ReceiptsGetData from "./ReceiptsTable/ReceiptsGetData"
import './Receipts.css'

const Receipts = () => {
  return (
    <>
      <ReceiptsGetData/>
    </>
  )
}

export default Receipts